/* eslint-disable vue/multi-word-component-names */
import { createApp } from "vue"
import "./index.css"
import App from "./App.vue"
import router from "./router"
import { createPinia } from "pinia"

// PrimeVue
import PrimeVue from "primevue/config"
import Dialog from "primevue/dialog"
import InputText from "primevue/inputtext"
import OverlayPanel from "primevue/overlaypanel"
import Button from "primevue/button"
import Avatar from "primevue/avatar"
import AvatarGroup from "primevue/avatargroup"
import Card from "primevue/card"
import Checkbox from "primevue/checkbox"
import Dropdown from "primevue/dropdown"
import DataTable from "primevue/datatable"
import Column from "primevue/column"
import InputMask from "primevue/inputmask"
import Tooltip from "primevue/tooltip"
import InputSwitch from "primevue/inputswitch"
import ColorPicker from "primevue/colorpicker"
import Sidebar from "primevue/sidebar"
import BadgeDirective from "primevue/badgedirective"
import Chips from "primevue/chips"
import MultiSelect from "primevue/multiselect"
import CascadeSelect from "primevue/cascadeselect"
import RadioButton from "primevue/radiobutton"
import Calendar from "primevue/calendar"
import TabView from "primevue/tabview"
import TabPanel from "primevue/tabpanel"
import Slider from "primevue/slider"
import ProgressBar from "primevue/progressbar"
import "primevue/resources/themes/tailwind-light/theme.css"
import "primevue/resources/primevue.min.css"

// Register quill modules
import Quill from "quill"
import "quill-emoji/dist/quill-emoji.css"
import ImageResize from "quill-image-resize"
import draggable from "vuedraggable"
import { cleaveDirective } from "@/shared/directives/cleave-directive"

// Vue Tel Input
import VueTelInput from "vue-tel-input"
import "vue-tel-input/vue-tel-input.css"

//Tanstack Query
import { VueQueryPlugin } from "@tanstack/vue-query"

// Sentry
import * as Sentry from "@sentry/vue"
import { createSentryPiniaPlugin } from "@sentry/vue"

/* eslint-disable */
const Emoji = require("quill-emoji")

const app = createApp(App)

app.use(VueTelInput)
app.use(PrimeVue)
app.use(VueQueryPlugin)

app.component("Dialog", Dialog)
app.component("InputText", InputText)
app.component("OverlayPanel", OverlayPanel)
app.component("Button", Button)
app.component("Avatar", Avatar)
app.component("AvatarGroup", AvatarGroup)
app.component("Card", Card)
app.component("Checkbox", Checkbox)
app.component("Dropdown", Dropdown)
app.component("DataTable", DataTable)
app.component("Column", Column)
app.component("InputMask", InputMask)
app.component("InputSwitch", InputSwitch)
app.component("ColorPicker", ColorPicker)
app.component("Sidebar", Sidebar)
app.component("draggable", draggable)
app.component("Chips", Chips)
app.component("MultiSelect", MultiSelect)
app.component("CascadeSelect", CascadeSelect)
app.component("RadioButton", RadioButton)
app.component("TabView", TabView)
app.component("TabPanel", TabPanel)
app.component("Slider", Slider)
app.component("ProgressBar", ProgressBar)
app.component("Calendar", Calendar)
app.directive("tooltip", Tooltip)
app.directive("badge", BadgeDirective)
app.directive("cleave", cleaveDirective)

const pinia = createPinia()

Sentry.init({
    app,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/vue/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
    integrations: [Sentry.replayIntegration()],
    // Enable logs to be sent to Sentry
    _experiments: { enableLogs: true },

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
})

pinia.use(createSentryPiniaPlugin())

app.use(pinia)

app.use(router)

router.isReady().then(() => {
    app.mount("#app")
})

Quill.register("modules/emoji", Emoji)
Quill.register("modules/imageResize", ImageResize)
